function prepCourseDetails({
    termDate,
    venues,
    activities,
    sessions,
    holidays,
}) {
    const venuesWithActivities = venues.map((venue) => ({
        ...venue,
        sessions: sessions.reduce(
            (sessionArray, session) => {
                if (
                    session.venue_id === venue.venue_id
                    && session.termdate_id === termDate.termdate_id
                ) {
                    return [
                        ...sessionArray,
                        {
                            ...session,
                            activity: {
                                ...activities.filter(
                                    (activity) => activity.activity_id === session.activity_id,
                                )[0],
                            },
                        },
                    ];
                }

                return sessionArray;
            },
            [],
        ),
    }));

    const termHolidays = holidays.filter((holiday) => holiday.termdate_id === termDate.termdate_id);

    const newTerm = {
        ...termDate,
        startDate: new Date(termDate.start),
        endDate: new Date(termDate.end),
        venues: [
            ...venuesWithActivities,
        ],
        holidays: [
            ...termHolidays,
        ],
    };

    return newTerm;
}

export default prepCourseDetails;
